import { LoadingState } from '../../../../types/loading-state';
import { createFetchedData } from '../../../../utils/fetched-data/create-fetched-data';
import { generateQueryKey } from '../../../../utils/generate-query-key';
import { browsingDomainStore } from '../../store';
export const getShowtimeIdsForQueryOnBusinessDate = (query, businessDate) => {
    const queryKey = generateQueryKey(query);
    const showtimeIdsForQuery = browsingDomainStore.data.showtimeIdsForQueryByBusinessDate[queryKey];
    const showtimeIdsForQueryOnDate = showtimeIdsForQuery && showtimeIdsForQuery[businessDate];
    return showtimeIdsForQueryOnDate || createFetchedData(LoadingState.NotLoaded);
};
